(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-faq-search]').forEach((wrap) => {
      const section = wrap.closest('.faq');
      if (!section) return;
      const input = wrap.querySelector('[data-faq-search-input]');
      const items = Array.from(section.querySelectorAll('[data-faq-item]'));
      const groups = Array.from(section.querySelectorAll('[data-faq-group]'));
      const nav = section.querySelector('.faq__nav');
      const empty = section.querySelector('[data-faq-empty]');

      const norm = (s) => (s || '').toLowerCase();
      items.forEach((it) => {
        it.dataset.text = norm(it.textContent);
      });

      input.addEventListener('input', () => {
        const q = norm(input.value).trim();
        let anyVisible = false;

        items.forEach((it) => {
          const match = q === '' || it.dataset.text.indexOf(q) !== -1;
          it.hidden = !match;
          if (match) anyVisible = true;
          if (q !== '' && match) {
            it.open = true;
          } else if (q === '') {
            it.open = false;
          }
        });

        groups.forEach((g) => {
          const hasVisible = g.querySelector('[data-faq-item]:not([hidden])');
          g.hidden = !hasVisible;
        });

        if (nav) nav.style.display = q === '' ? '' : 'none';
        if (empty) empty.hidden = anyVisible;
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (() => {
    // Re-initialised on every theme-editor re-render of the header, otherwise the scroll
    // listener keeps pointing at the old (removed) header and the logo swap stops working.
    let teardown = null;

    const initDrawer = (header) => {
      const drawer = document.getElementById('MenuDrawer');
      const openBtn = header.querySelector('[data-menu-open]');
      if (!drawer || !openBtn) return;

      const closeDrawer = () => {
        drawer.close();
      };

      openBtn.addEventListener('click', () => {
        drawer.showModal();
        openBtn.setAttribute('aria-expanded', 'true');
        document.body.style.overflow = 'hidden';
      });

      drawer.addEventListener('close', () => {
        openBtn.setAttribute('aria-expanded', 'false');
        document.body.style.overflow = '';
      });

      drawer.addEventListener('click', (event) => {
        if (event.target === drawer) closeDrawer();
      });

      drawer.querySelectorAll('[data-menu-close]').forEach((btn) => {
        btn.addEventListener('click', closeDrawer);
      });
    };

    const initTransparent = (header) => {
      if (!header.hasAttribute('data-transparent')) return null;

      document.body.classList.add('header-is-transparent');

      const setOffset = () => {
        document.documentElement.style.setProperty('--header-overlay-h', header.offsetHeight + 'px');
      };

      const onScroll = () => {
        header.classList.toggle('is-solid', window.scrollY > 24);
      };

      setOffset();
      onScroll();
      window.addEventListener('resize', setOffset);
      window.addEventListener('scroll', onScroll, { passive: true });

      // Logo images load after this runs and change the header height — keep the overlay offset in sync.
      let observer = null;
      if ('ResizeObserver' in window) {
        observer = new ResizeObserver(setOffset);
        observer.observe(header);
      }

      return () => {
        window.removeEventListener('resize', setOffset);
        window.removeEventListener('scroll', onScroll);
        if (observer) observer.disconnect();
      };
    };

    const destroy = () => {
      if (teardown) teardown();
      teardown = null;
      document.body.classList.remove('header-is-transparent');
      document.documentElement.style.removeProperty('--header-overlay-h');
      document.body.style.overflow = '';
    };

    const init = () => {
      destroy();
      const header = document.getElementById('SiteHeader');
      if (!header) return;
      initDrawer(header);
      teardown = initTransparent(header);
    };

    const isHeaderSection = (event) => event.target && event.target.querySelector && event.target.querySelector('#SiteHeader');

    document.addEventListener('shopify:section:unload', (event) => {
      if (isHeaderSection(event)) destroy();
    });

    document.addEventListener('shopify:section:load', (event) => {
      if (isHeaderSection(event)) init();
    });

    init();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-cinematic"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.cine').forEach((cine) => {
    const slides = cine.querySelectorAll('.cine__slide');
    const tabs = cine.querySelectorAll('.cine__tab');
    const counter = cine.querySelector('.cine__counter-current');
    if (slides.length < 2) return;

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const autoplay = cine.dataset.autoplay === 'true' && !reduceMotion;
    const speed = (parseInt(cine.dataset.speed, 10) || 7) * 1000;
    let current = 0;
    let timer = null;

    const pad = (n) => String(n + 1).padStart(2, '0');

    const restartFill = (tab) => {
      const fill = tab.querySelector('.cine__tab-fill');
      if (!fill) return;
      fill.style.animation = 'none';
      void fill.offsetWidth;
      fill.style.animation = '';
    };

    const goTo = (index) => {
      slides[current].classList.remove('is-active');
      slides[current].setAttribute('aria-hidden', 'true');
      tabs[current].classList.remove('is-active');
      current = (index + slides.length) % slides.length;
      slides[current].classList.add('is-active');
      slides[current].removeAttribute('aria-hidden');
      tabs[current].classList.add('is-active');
      if (counter) counter.textContent = pad(current);
      restartFill(tabs[current]);
    };

    const stop = () => {
      if (timer) clearInterval(timer);
      cine.classList.remove('cine--playing');
    };

    const start = () => {
      if (!autoplay) return;
      stop();
      cine.classList.add('cine--playing');
      restartFill(tabs[current]);
      timer = setInterval(() => goTo(current + 1), speed);
    };

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        goTo(parseInt(tab.dataset.cineTo, 10));
        start();
      });
    });

    cine.addEventListener('mouseenter', stop);
    cine.addEventListener('mouseleave', start);
    cine.addEventListener('focusin', stop);
    cine.addEventListener('focusout', start);
    start();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.hero').forEach((hero) => {
    const slides = hero.querySelectorAll('.hero__slide');
    const dots = hero.querySelectorAll('.hero__dot');
    if (slides.length < 2) return;

    let current = 0;
    let timer = null;
    const autoplay = hero.dataset.autoplay === 'true';
    const speed = (parseInt(hero.dataset.speed, 10) || 6) * 1000;
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const goTo = (index) => {
      slides[current].classList.remove('is-active');
      slides[current].setAttribute('aria-hidden', 'true');
      dots[current].classList.remove('is-active');
      current = (index + slides.length) % slides.length;
      slides[current].classList.add('is-active');
      slides[current].removeAttribute('aria-hidden');
      dots[current].classList.add('is-active');
    };

    const stop = () => timer && clearInterval(timer);
    const start = () => {
      if (!autoplay || reduceMotion) return;
      stop();
      timer = setInterval(() => goTo(current + 1), speed);
    };

    dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        goTo(parseInt(dot.dataset.slideTo, 10));
        start();
      });
    });

    hero.addEventListener('mouseenter', stop);
    hero.addEventListener('mouseleave', start);
    hero.addEventListener('focusin', stop);
    hero.addEventListener('focusout', start);
    start();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  document.querySelectorAll('.cart').forEach((root) => {
    root.querySelectorAll('[data-cart-qty]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const input = btn.closest('.qty-box').querySelector('[data-cart-input]');
        const next = parseInt(input.value, 10) + parseInt(btn.dataset.cartQty, 10);
        input.value = Math.max(0, next || 0);
        input.form.querySelector('[name="update"]')?.click();
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  document.querySelectorAll('.product').forEach((root) => {
    const sectionId = root.id.replace('Product-', '');
    const jsonEl = document.getElementById('ProductJson-' + sectionId);
    const invEl = document.getElementById('ProductInventory-' + sectionId);
    const stage = root.querySelector('#ProductStageImage');

    root.querySelectorAll('.product__thumb').forEach((thumb) => {
      thumb.addEventListener('click', () => {
        if (!stage) return;
        stage.src = thumb.dataset.fullSrc;
        stage.removeAttribute('srcset');
        root.querySelectorAll('.product__thumb').forEach((t) => t.classList.remove('is-active'));
        thumb.classList.add('is-active');
      });
    });

    const accordions = root.querySelectorAll('.product__accordion');
    accordions.forEach((acc) => {
      acc.addEventListener('toggle', () => {
        if (!acc.open) return;
        accordions.forEach((other) => {
          if (other !== acc) other.open = false;
        });
      });
    });

    root.querySelectorAll('[data-qty-change]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const input = root.querySelector('#ProductQty');
        const next = parseInt(input.value, 10) + parseInt(btn.dataset.qtyChange, 10);
        input.value = Math.max(1, next || 1);
      });
    });

    const buybar = root.querySelector('#ProductBuybar');
    const mainAdd = root.querySelector('#ProductAddButton');
    if (buybar && mainAdd && 'IntersectionObserver' in window) {
      const watcher = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            const show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
            buybar.classList.toggle('is-visible', show);
            buybar.setAttribute('aria-hidden', show ? 'false' : 'true');
          });
        },
        { threshold: 0 }
      );
      watcher.observe(mainAdd);
    }

    if (!jsonEl) return;
    const productData = JSON.parse(jsonEl.textContent);
    const invData = invEl ? JSON.parse(invEl.textContent) : null;
    const selects = root.querySelectorAll('.product__option-select');
    const idInput = root.querySelector('#ProductVariantId');
    const priceEl = root.querySelector('#ProductPrice');
    const saveEl = root.querySelector('#ProductSave');
    const stockEl = root.querySelector('#ProductStock');
    const buybarPrice = root.querySelector('#ProductBuybarPrice');
    const buybarBtn = root.querySelector('.product__buybar-btn');
    const addBtn = root.querySelector('#ProductAddButton');
    const money = (cents) => '₹' + Number((cents / 100).toFixed(2).replace(/\.00$/, '')).toLocaleString('en-IN');

    const renderStock = (variant) => {
      if (!stockEl || !invData) return;
      const inv = invData.variants[String(variant.id)];
      let dotClass = '';
      let label = invData.labels.in_stock;
      if (!variant.available) {
        dotClass = 'product__stock-dot--out';
        label = invData.labels.sold_out;
      } else if (inv && inv.tracked && inv.qty > 0 && inv.qty <= invData.threshold) {
        dotClass = 'product__stock-dot--low';
        label = invData.labels.only_left.replace('[count]', inv.qty);
      }
      stockEl.innerHTML =
        '<span class="product__stock-dot ' + dotClass + '" aria-hidden="true"></span>' + label;
    };

    const onChange = () => {
      const chosen = Array.from(selects).map((s) => s.value);
      const variant = productData.variants.find((v) =>
        chosen.every((value, i) => v.options[i] === value)
      );
      if (!variant) return;
      idInput.value = variant.id;
      if (priceEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          priceEl.innerHTML =
            '<span class="price--compare">' + money(variant.compare_at_price) + '</span>' +
            '<span class="price--sale">' + money(variant.price) + '</span>';
        } else {
          priceEl.textContent = money(variant.price);
        }
      }
      if (saveEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          const pct = Math.round(((variant.compare_at_price - variant.price) * 100) / variant.compare_at_price);
          const tpl = saveEl.dataset.saveTemplate || 'Save [pct]%';
          saveEl.textContent = tpl.replace('[pct]', pct);
          saveEl.hidden = false;
        } else {
          saveEl.hidden = true;
        }
      }
      if (buybarPrice) buybarPrice.textContent = money(variant.price);
      if (addBtn) {
        addBtn.disabled = !variant.available;
        addBtn.textContent = variant.available ? addBtn.dataset.labelAdd : addBtn.dataset.labelSoldOut;
      }
      if (buybarBtn) buybarBtn.disabled = !variant.available;
      renderStock(variant);
      if (variant.featured_image && stage) {
        stage.src = variant.featured_image.src;
        stage.removeAttribute('srcset');
      }
    };

    selects.forEach((s) => s.addEventListener('change', onChange));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["occasion-cards"] && !Shopify.designMode) return;
  try {
    
  (() => {
    // Gentle scroll parallax for the occasion panels. Runs only while a section is on
    // screen, batches work into one animation frame, and is skipped for reduced motion.
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const visible = new Set();
    let ticking = false;

    const update = () => {
      ticking = false;
      const vh = window.innerHeight;
      visible.forEach((section) => {
        section.querySelectorAll('[data-parallax]').forEach((layer) => {
          const rect = layer.parentElement.getBoundingClientRect();
          const progress = (rect.top + rect.height / 2 - vh / 2) / (vh / 2 + rect.height / 2);
          const clamped = Math.max(-1, Math.min(1, progress));
          layer.style.setProperty('--py', (clamped * 5.5).toFixed(2) + '%');
        });
      });
    };

    const requestUpdate = () => {
      if (ticking || visible.size === 0 || reduceMotion.matches) return;
      ticking = true;
      requestAnimationFrame(update);
    };

    const observer =
      'IntersectionObserver' in window
        ? new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                if (entry.isIntersecting) visible.add(entry.target);
                else visible.delete(entry.target);
              });
              requestUpdate();
            },
            { rootMargin: '10% 0px' }
          )
        : null;

    const init = (root) => {
      if (!observer) return;
      root.querySelectorAll('[data-occasions]').forEach((section) => observer.observe(section));
    };

    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate);

    document.addEventListener('shopify:section:load', (event) => init(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      event.target.querySelectorAll('[data-occasions]').forEach((section) => {
        visible.delete(section);
        if (observer) observer.unobserve(section);
      });
    });

    init(document);
  })();

  } catch(e) { console.error(e); }
})();
})();
